// segnalazioni.ts — motivi di segnalazione e lunghezza della nota, uguali per app e API.
export const MOTIVI_SEGNALAZIONE = ["nudita", "molestie", "odio", "minore", "violenza", "spam", "altro"] as const;
export type MotivoSegnalazione = (typeof MOTIVI_SEGNALAZIONE)[number];
export const NOTA_MAX = 500;
